import React from 'react'
import { Outlet } from 'react-router-dom'

import {
  Box,
  CssBaseline,
  Toolbar,
  AppBar,
  IconButton,
  Container, 
} from '@mui/material'

import AuthenticatedNavigation from '../AuthenticatedNavigation'
import StikisLogoTiny from 'images/stikis_logo-img_only-small.png'
import StaticFlash from '../static/StaticFlash'
import StaticFooter from '../static/StaticFooter'
import StaticTopMenu from '../static/StaticTopMenu'

const classes = {}

export default function StaticFormLayout() {

  return (
    <React.Fragment>
      <StaticTopMenu />
      <Container component="main" maxWidth="md">
        <StaticFlash />
        <Box
          sx={{
            marginTop: 9,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Outlet />
        </Box>
      </Container>
      <StaticFooter />
    </React.Fragment>
  )
}